import { reactive } from "vue";

// Name shown in the brand lockups (app bar, welcome screen, sign-in pages). The site answers on several domains,
// each with its own name; a visitor may pick another one in Mon profil. The choice is kept per device in
// localStorage, like the theme, so it also works without an account. SEO titles and structured data keep the
// official name (utils/seo.js).
const STORAGE_KEY = "qwwSiteNamePreference";
export const AUTO_SITE_NAME = "auto";

// lead / accent: the two halves of the lockup ("Québec" in the main colour, "Eau Vive" in the accent colour)
export const SITE_NAMES = {
  "eau-vive": { label: "Québec Eau Vive", lead: "Québec", accent: "Eau Vive" },
  whitewater: { label: "Quebec Whitewater", lead: "Quebec", accent: "Whitewater" },
  "kayak-quebec": { label: "Kayak Québec", lead: "Kayak", accent: "Québec" },
};
export const DEFAULT_SITE_NAME = "eau-vive";

const DOMAIN_SITE_NAMES = [
  { domain: "kayakquebec.ca", name: "kayak-quebec" },
  { domain: "quebecwhitewater.com", name: "whitewater" },
  { domain: "quebeceauvive.com", name: "eau-vive" },
];

const isValidPreference = (value) => value === AUTO_SITE_NAME || Object.hasOwn(SITE_NAMES, value);

// Name that goes with the domain (www. and other subdomains included); the official name elsewhere
// (localhost, Firebase preview channels, prerendering).
export function getSiteNameForHostname(hostname) {
  const host = String(hostname || "").toLowerCase();
  const match = DOMAIN_SITE_NAMES.find(({ domain }) => host === domain || host.endsWith(`.${domain}`));
  return match ? match.name : DEFAULT_SITE_NAME;
}

function readStoredPreference() {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isValidPreference(stored) ? stored : AUTO_SITE_NAME;
  } catch {
    return AUTO_SITE_NAME;
  }
}

const state = reactive({ preference: readStoredPreference() });

export function getSiteNamePreference() {
  return state.preference;
}

export function setSiteNamePreference(preference) {
  if (!isValidPreference(preference)) {
    return;
  }
  state.preference = preference;
  try {
    if (preference === AUTO_SITE_NAME) {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, preference);
    }
  } catch {
    // Private mode or blocked storage: the choice only lasts for this visit
  }
}

export function getDomainSiteName() {
  return SITE_NAMES[getSiteNameForHostname(window.location.hostname)];
}

// Reactive: components that read it in a computed update when the choice changes
export function getSiteName() {
  return state.preference === AUTO_SITE_NAME ? getDomainSiteName() : SITE_NAMES[state.preference];
}
